/** @typedef	{import('../../../../shared/SubscriptionCheckout/SubscriptionPlans/Tier').default} Tier */

import { translate } from '../../../Internationalization';

/** @type {Tier[]} */
export default [
	{
		description: translate('subscription.plans.free.description'),
		features: [
			translate('subscription.plans.free.features.1'),
			[
				translate('subscription.plans.free.features.2'),
				translate('subscription.plans.free.features.3'),
				translate('subscription.plans.free.features.4'),
				translate('subscription.plans.free.features.5'),
			],
			translate('subscription.plans.free.features.6'),
			[translate('subscription.plans.free.features.7')],
			translate('subscription.plans.free.features.8'),
			[translate('subscription.plans.free.features.9')],
			translate('subscription.plans.free.features.13'),
			[translate('subscription.plans.free.features.14')],
			translate('subscription.plans.free.features.10'),
			[
				translate('subscription.plans.free.features.15'),
				translate('subscription.plans.free.features.11'),
				translate('subscription.plans.free.features.12'),
			],
			translate('subscription.plans.free.features.16'),
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 0,
		title: 'free',
	},
	{
		description: translate('subscription.plans.starter.description'),
		features: [
			// translate('subscription.plans.starter.features.1'),
			translate('subscription.plans.starter.features.2'),
			[translate('subscription.plans.starter.features.3')],
			translate('subscription.plans.starter.features.15'),
			[translate('subscription.plans.starter.features.12')],
			translate('subscription.plans.starter.features.4'),
			[
				translate('subscription.plans.starter.features.5'),
				translate('subscription.plans.starter.features.6'),
			],
			translate('subscription.plans.starter.features.10'),
			[translate('subscription.plans.starter.features.11')],
			translate('subscription.plans.starter.features.8'),
			[translate('subscription.plans.starter.features.9')],
			translate('subscription.plans.starter.features.16'),
			[
				translate('subscription.plans.starter.features.13'),
				translate('subscription.plans.starter.features.7'),
			],
			translate('subscription.plans.starter.features.14'),
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 495,
		title: 'starter',
	},
	{
		description: translate('subscription.plans.standard.description'),
		features: [
			// translate('subscription.plans.standard.features.1'),
			translate('subscription.plans.standard.features.2'),
			[
				translate('subscription.plans.standard.features.13'),
				translate('subscription.plans.standard.features.14'),
			],
			translate('subscription.plans.standard.features.15'),
			[translate('subscription.plans.standard.features.9')],
			translate('subscription.plans.standard.features.3'),
			[translate('subscription.plans.standard.features.4')],
			translate('subscription.plans.standard.features.11'),
			[translate('subscription.plans.standard.features.12')],
			translate('subscription.plans.standard.features.5'),
			[
				translate('subscription.plans.standard.features.6'),
				translate('subscription.plans.standard.features.7'),
			],
			translate('subscription.plans.standard.features.16'),
			[translate('subscription.plans.standard.features.8')],

			translate('subscription.plans.external_cta'),
		],
		popular: true,
		pricePerMonth: 995,
		title: 'standard',
	},
	{
		description: translate('subscription.plans.professional.description'),
		features: [
			translate('subscription.plans.professional.features.1'),
			translate('subscription.plans.professional.features.2'),
			translate('subscription.plans.professional.features.3'),
			[translate('subscription.plans.professional.features.4')],
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 1995,
		title: 'professional',
	},
	{
		description: translate('subscription.plans.enterprise.description'),
		features: [
			translate('subscription.plans.enterprise.features.1'),
			translate('subscription.plans.enterprise.features.2'),
			translate('subscription.plans.enterprise.features.3'),
			translate('subscription.plans.enterprise.features.4'),
			translate('subscription.plans.enterprise.features.5'),
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 0,
		title: 'enterprise',
	},
];
